(function() {
  var loaded = false;
  var pendingLauncherClick = false;

  function isWhatsAppTarget(target) {
    return !!(target && target.closest && target.closest('#wcWhatsAppLauncher, #wcWhatsAppBox'));
  }

  function replayLauncherClick() {
    if (!pendingLauncherClick) return;
    pendingLauncherClick = false;

    var launcher = document.getElementById('wcWhatsAppLauncher');
    if (launcher) launcher.click();
  }

  function loadWhatsAppScript() {
    if (loaded) return;

    var scriptUrl = window.__WC_WHATSAPP_SCRIPT_URL__;
    if (!scriptUrl) return;

    loaded = true;

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.defer = true;
    script.addEventListener('load', replayLauncherClick);
    document.body.appendChild(script);
  }

  document.addEventListener('pointerdown', function(event) {
    var whatsappTarget = event.target && event.target.closest && event.target.closest('#wcWhatsAppLauncher, #wcWhatsAppBox');
    if (!whatsappTarget || !isWhatsAppTarget(event.target)) return;

    if (whatsappTarget.id === 'wcWhatsAppLauncher') {
      pendingLauncherClick = true;
    }

    loadWhatsAppScript();
  }, true);

  document.addEventListener('keydown', function(event) {
    var whatsappTarget = event.target && event.target.closest && event.target.closest('#wcWhatsAppLauncher, #wcWhatsAppBox');
    if (!whatsappTarget || !isWhatsAppTarget(event.target)) return;

    if (whatsappTarget.id === 'wcWhatsAppLauncher' && (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')) {
      pendingLauncherClick = true;
    }

    loadWhatsAppScript();
  }, true);

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadWhatsAppScript, { timeout: 10000 });
  } else {
    setTimeout(loadWhatsAppScript, 10000);
  }
})();
